import { Component, OnInit, Input } from '@angular/core';

import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import {MatTableDataSource} from '@angular/material/table';

import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Label } from 'ng2-charts';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';
import {TranslateService} from '@ngx-translate/core';

export interface PeriodicElement {
  name: string;
  porcentaje: number;
  nivel: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {name: 'Ambiente de trabajo', porcentaje:7.23, nivel: 'Bajo'},
  {name: 'Factores propios de la actividad', porcentaje: 48.38, nivel: 'Alto'},
  {name: 'Organización del tiempo de trabajo', porcentaje: 6.75, nivel: 'Bajo'},
  {name: 'Liderazgo y relaciones en el trabajo', porcentaje: 25.57, nivel: 'Bajo'},
  {name: 'Entorno organizacional', porcentaje: 13.08, nivel: 'Bajo'}
]

@Component({
  selector: 'app-tablero-categoria',
  templateUrl: './tablero-categoria.component.html',
  styleUrls: ['./tablero-categoria.component.scss']
})
export class TableroCategoriaComponent implements OnInit {
  @Input() productoID: any;
  @Input() centroDeTrabajoId:any;

  cargando:boolean=true;
  urlCTIndividual:any;
  tablaCategoria: MatTableDataSource<backInter.Categorias>;

  displayedColumns: string[] = ['nombre', 'porcentaje', 'nivel'];
  dataSource = ELEMENT_DATA;

   barChartOptions: ChartOptions;
   barChartLabels: Label[];
   barChartType: ChartType;
   barChartLegend:any;
   barChartPlugins:any;
   barChartData: ChartDataSets[];
   barChartColors:any;

   graficaDatos:any[]=[];
   graficaLabels:any[]=[];
   graficaColors:any[]=[];

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private translateSrv: TranslateService
  ) {
    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    // this.graficoBarras();
    this.getTableros();
    console.log(this.productoID);
    console.log(this.centroDeTrabajoId);
  }

  getTableros(){
    let data={
      productoId: this.productoID,
      id_CT:this.centroDeTrabajoId
    }
    if(localStorage.getItem('empresaPadre')){
      this.urlCTIndividual=localStorage.getItem('empresaPadre');
    }
    else{
      this.urlCTIndividual="";
    }
    this.wizardService.getTableros(this.urlCTIndividual, data).subscribe( (datos: backInter.tableroGlobal) => {
      console.log(datos);
      this.tablaCategoria = new MatTableDataSource(datos.categorias);
      datos.categorias.forEach(element => {
        this.graficaLabels.push(element.DimensionOrCategoryName);
        this.graficaDatos.push(element.value);

        switch (element.valorColor) {
          case 1:
            this.graficaColors.push('rgba(0, 176, 240)');
          break;

          case 2:
            this.graficaColors.push('rgba(146, 208, 80)');
          break;

          case 3:
            this.graficaColors.push('rgba(255, 255, 0)');
          break;

          case 4:
            this.graficaColors.push('rgba(255, 192, 0)');
          break;

          case 5:
            this.graficaColors.push('rgba(255, 0, 0)');
          break;

          default:
            break;
        }
      });
      this.graficaDatos.push(0);
      this.graficoBarras(this.graficaDatos,this.graficaLabels, this.graficaColors);
    });
  }

  graficoBarras(datos:any, labels:any, colors:any){
    let label = 'SECCIONES.TABLERO_CATEGORIA.LABEL';
    this.translateSrv.get(label).subscribe((res: string) => { label = res; });
    this.barChartOptions= {
    responsive: true,
    legend: {
      labels: {
        boxWidth:0,
        fontColor: 'rgb(0, 0, 0)',
        fontStyle: 'bold'
           }
    },
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{}] },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  this.barChartLabels= labels;
  this.barChartType= 'bar';
  this.barChartLegend = true;
  this.barChartPlugins = [pluginDataLabels];

  this.barChartData=[
    { data: datos, label: label }
  ];

  this.barChartColors = [
   {
     backgroundColor: colors,
     borderColor:['rgba(146, 208, 80)']
   }
 ];
 this.cargando=false;
  }

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

}
